import { FormGroup, FormParagraph, Text } from '@ksyos/design-system';
import type { ITimeSlots } from '@common/validation/timeSlots';
import { translateKey } from '@frontend/translate';
import { TimeRangeRead } from './TimeRangeRead';

interface ITimeRangesReadProps {
    timeSlots?: ITimeSlots;
}

export function TimeRangesRead(props: ITimeRangesReadProps) {
    const notEmptyFirstTimeRange = !!props.timeSlots?.firstTimeRange.startTime;
    const notEmptySecondTimeRange = !!props.timeSlots?.secondTimeRange.startTime;

    return (
        <FormGroup label={translateKey('contactsAndTasks.availability')}>
            {notEmptyFirstTimeRange || notEmptySecondTimeRange ? (
                <FormParagraph>
                    {notEmptyFirstTimeRange && <TimeRangeRead interval={props.timeSlots!.firstTimeRange} />}
                    {notEmptySecondTimeRange && notEmptyFirstTimeRange && (
                        <Text
                            as="span"
                            fontWeight="medium"
                            ml={2}
                            mr={2}
                            size="sm"
                        >
                            {translateKey('common.and')}
                        </Text>
                    )}
                    {notEmptySecondTimeRange && <TimeRangeRead interval={props.timeSlots!.secondTimeRange} />}
                </FormParagraph>
            ) : (
                <FormParagraph>-</FormParagraph>
            )}
        </FormGroup>
    );
}
